<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">รายงานการส่งพัสดุที่น้ำหนักเกิน</h1>
                    <p class="text-white pb-3 px-3">แสดงข้อมูลรายการส่งด้วยระบบ SHIPPOP ที่มีน้ำหนักเกิน</p>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-lg-7">
                                    <b-form-group id="input-group-1" label="ค้นหาวันที่ทำรายการ (วันเริ่มต้น - วันสุดท้าย)" label-for="input-1" class="mb-0">
                                        <div class="row align-self-center">
                                            <div class="col-lg-5">
                                                <date-range-picker
                                                    class="w-100"
                                                    :opens="'center'"
                                                    :singleDatePicker="false"
                                                    :appendToBody="true"
                                                    :ranges="false"
                                                    :closeOnEsc="false"
                                                    :autoApply="true"
                                                    :locale-data="{ format: 'dd-mm-yyyy' }"
                                                    v-model="filters">
                                                </date-range-picker>
                                            </div>
                                            <div class="col-lg-5">
                                                <b-form-input v-model="filter" type="text" placeholder="Tracking No, ร้านค้า, เจ้าของร้าน"></b-form-input>
                                            </div>
                                            <div class="col-lg-2">
                                                <button class="btn btn-info btn-sm-res">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <hr class="d-block d-md-none d-lg-none mb-0" />
                                </div>
                                <div class="col-lg-3">
                                    <b-form-group id="input-group-1" label="สถานะ" label-for="input-1" class="mb-0">
                                        <select class="form-control" v-model="filterStatus">
                                            <option :value="status.key" v-for="status in dataStatus" :key="status.key">{{status.title}}</option>
                                        </select>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-2">
                                    <b-form-group label="Export File" class="mb-0 pb-2">
                                        <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                                            <ExportExcel 
                                                :columns="fields" 
                                                :getData="[]"
                                                name="สรุปการใช้งาน wellet " 
                                            >
                                            </ExportExcel>
                                            <b-button variant="info btn-sm-res" @click="$htmlToPaper('tablePrint')">print</b-button>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div id="tablePrint">
                            <b-table
                                refs="overWeightTable"
                                show-empty
                                responsive
                                :items="[]"
                                :fields="fields"
                                :filter="filter"
                                :busy="busy"
                                @row-selected="onRowSelected"
                                class="scroll-bar-pop"
                                selectable
                                hover
                                foot-clone
                            >
                                <div slot="table-busy" class="text-center">
                                    <BlockUI>
                                        <div class="loader"></div>
                                    </BlockUI>
                                </div>
                                <template slot="HEAD_selected">
                                    <b-form-checkbox v-model="checkSelect" @change="selectAllRows()">
                                    </b-form-checkbox>
                                </template>
                                <template slot="selected" slot-scope="{ rowSelected , item }">
                                    <template v-if="rowSelected">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" autocomplete="off" class="custom-control-input" value="true" checked>
                                            <label class="custom-control-label"></label>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" autocomplete="off" class="custom-control-input" value="false">
                                            <label class="custom-control-label"></label>
                                        </div>
                                    </template>
                                </template>
                                <template slot="index" slot-scope="data">{{ data.index+1 }}</template>

                                <template slot="FOOT_selected">&nbsp;</template>
                                <template slot="FOOT_index">รวม</template>
                                <template slot="FOOT_a">&nbsp;</template>
                                <template slot="FOOT_z">&nbsp;</template>
                                <template slot="FOOT_s">&nbsp;</template>
                                <template slot="FOOT_w">&nbsp;</template>
                                <template slot="FOOT_g">&nbsp;</template>
                                <template slot="FOOT_h">&nbsp;</template>
                                <template slot="FOOT_p">&nbsp;</template>
                                <template slot="FOOT_ps">&nbsp;</template>
                                <template slot="FOOT_pe"></template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'

export default {
    name: "reportoverweight",
    components:{
        ExportExcel
    },
    data() {
        return {
            busy: false,
            filters: {
                excelDate: "",
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
            filter: null,
            filterStatus: null,
            dataStatus:[
                { key: null , title:'ดูสถานะทั้งหมด'},
                { key: '1' , title: 'สำเร็จ' }, 
                { key: '0' , title: 'รออนุมัติ' }, 
                { key: '-1' , title: 'ไม่อนุมัติ' }
            ],
            checkSelect:"",
        }
    },
    mounted() {
    },
    methods: {
        selectAllRows(){
            this.checkSelect = !this.checkSelect
            if (this.checkSelect){
                this.$refs.overWeightTable.selectAllRows()
            }else{
                this.$refs.overWeightTable.clearSelected()
            }
        },
        unselectRow(index) {
            this.$refs.overWeightTable.unselectRow(index)
        },
        onRowSelected(items){
        },
        reportOverWeight(){
            this.$http
                .post(
                this.$API_URL + "/",
                {
                    
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                }
                )
                .then(res => {
                    
                })
                .catch(error => {
                });
        },
    },
    computed: {
        fields(){ 
            let fields = [
                { key: "selected", field: "selected", label: "checkbox" },
                { key: "index", field: "index", label: "ลำดับ", sortable: true },
                { key: "a", field: "a", label: "วันเวลาที่ทำรายการ", sortable: true },
                { key: "z", field: "z", label: "หมายเลข Tracking", sortable: true },
                { key: "s", field: "s", label: "ชื่อขนส่ง", sortable: true },
                { key: "w", field: "w", label: "ชื่อร้านค้า", sortable: true },
                { key: "g", field: "g", label: "ชื่อเจ้าของร้าน", sortable: true },
                { key: "h", field: "h", label: "สถานะ", sortable: true },
                { key: "p", field: "p", label: "ยอดค้างชำระ", sortable: true },
                { key: "ps", field: "ps", label: "ขนาดพัสดุ", sortable: true },
                { key: "pe", field: "pe", label: "ขนาดพัสดุจริง", sortable: true }
            ]
            return fields
        },
    }
};
</script>